// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorWrapper_container__eMSOJ","section":"ErrorWrapper_section__F5_zC","message":"ErrorWrapper_message__w0o_Z"};